export default "__VITE_ASSET__BN19JTtO__"